import {
  IFilterEligibleTasks,
  IFilterQaReviews,
  IManualSelectionPayload,
  IRandomSelectionPayload,
} from "@/features/check/check.types";
import { AxiosResponse } from "axios";
import { http } from "@/utils/http";
import { cleanParams } from "@/utils/cleanParams";

export const checkService = {
  getEligibleTasks(filter?: IFilterEligibleTasks): Promise<AxiosResponse> {
    return http.get("/manual-qa/eligible-tasks", {
      params: cleanParams(filter),
    });
  },

  createManualSelection(
    payload: IManualSelectionPayload
  ): Promise<AxiosResponse> {
    return http.post("/manual-qa/select/manual", payload);
  },

  createRandomSelection(
    payload: IRandomSelectionPayload
  ): Promise<AxiosResponse> {
    return http.post("/manual-qa/select/random", payload);
  },

  getManualQaReviews(filter?: IFilterQaReviews): Promise<AxiosResponse> {
    return http.get("/manual-qa/reviews", {
      params: cleanParams(filter),
    });
  },

  startManualQaReview(
    review_id: string,
    filter: { organization_id: string }
  ): Promise<AxiosResponse> {
    return http.post(
      `/manual-qa/reviews/${review_id}/start`,
      {},
      {
        params: cleanParams(filter),
      }
    );
  },

  holdManualQaReview(
    review_id: string,
    hold_reason: string,
    filter: { organization_id: string }
  ): Promise<AxiosResponse> {
    return http.post(
      `/manual-qa/reviews/${review_id}/hold`,
      {
        hold_reason: hold_reason,
      },
      {
        params: cleanParams(filter),
      }
    );
  },

  resumeManualQaReview(
    review_id: string,
    filter: { organization_id: string }
  ): Promise<AxiosResponse> {
    return http.post(
      `/manual-qa/reviews/${review_id}/resume`,
      {},
      {
        params: cleanParams(filter),
      }
    );
  },

  completeManualQaReview(
    review_id: string,
    result: string,
    comment: string,
    filter: { organization_id: string }
  ): Promise<AxiosResponse> {
    return http.post(
      `/manual-qa/reviews/${review_id}/complete`,
      {
        result: result,
        comment: comment,
      },
      {
        params: cleanParams(filter),
      }
    );
  },

  archiveQaReview(
    review_id: string,
    filter: { organization_id: string }
  ): Promise<AxiosResponse> {
    return http.patch(
      `/manual-qa/reviews/${review_id}/archive`,
      {},
      {
        params: cleanParams(filter),
      }
    );
  },
};
